import { fg } from '@atlaskit/platform-feature-flags';

import { type EditionAwarenessContextType } from './edition-awareness-context';
import { isProductOneOf } from './is-product-one-of';

export function isEligibleForEAtoOSBExperiment(context: EditionAwarenessContextType): boolean {
	const { isInTrial, isInPredunning, invoiceableStatus, canAddPaymentDetails, product, edition } =
		context;

	return Boolean(
		(isInTrial || isInPredunning) &&
			edition === 'standard' &&
			invoiceableStatus === 'NOT_INVOICEABLE' &&
			canAddPaymentDetails &&
			isProductOneOf(product, ['jira', 'confluence']) &&
			fg('ea_to_osb_kill_switch'),
	);
}
